import StepId from "@/model/progress/StepId";

const providerKey = "synchrony_standard*"

export default {
    providerKey,

    routes: [
        {
            name: "payLaterResumeAfterFullApply",
            path: `/providers/${providerKey}/resume/after-full-apply`,
            meta: { stepper: false },
            redirect: () => {
                return `/providers/${providerKey}/payLaterLoader`
            },
        },
        {
            name: "offerReviewNext",
            path: `/providers/${providerKey}/offerReviewNext`,
            meta: { step: StepId.ACCEPT_OFFER },
            component: () => import("@/views/provider/synchrony/SynchronyTermsView"),
        },
        {
            name: "synchronyPaymentPlanReview",
            path: `/providers/${providerKey}/paymentPlanReview`,
            meta: { step: StepId.ACCEPT_OFFER },
            extends: "paymentPlanReview",
            component: () =>
                import(
                    /* webpackChunkName: "synchrony" */ "@/views/provider/synchrony/SynchronyPaymentPlanReviewView.vue"
                ),
        },
        {
            name: "payLaterIframe",
            path: `/providers/${providerKey}/payLaterIframe`,
            component: () => import("@/views/provider/synchrony/PayLaterIframe.vue"),
        },
        {
            name: "payLaterDecision",
            path: `/providers/${providerKey}/payLaterDecision`,
            component: () => import("@/views/provider/synchrony/PayLaterDecisionView.vue"),
        },
        {
            name: "payLaterLoader",
            path: `/providers/${providerKey}/payLaterLoader`,
            component: () => import("@/views/provider/synchrony/PayLaterLoaderView.vue"),
        },
        {
            name: "existingAccount",
            path: `/providers/${providerKey}/existingAccount`,
            component: () => import("@/views/provider/synchrony/SynchronyExistingAccountView.vue"),
        },
        {
            name: "finishWithExistingAccount",
            path: `/providers/${providerKey}/finishWithExistingAccount`,
            meta: { step: StepId.COMPLETE },
            component: () => import("@/views/provider/synchrony/SynchronyFinishWithExistingAccountView.vue"),
        },
    ],
}
